import { WebviewTenant } from '@enums/webview-tenant'

export const TenantActionValue = {
  [WebviewTenant.ACKODRIVE]: {
    background_color: '#000000',
    back_button_color: '#FFFFFF',
    status_icon_brightness: 'light',
  },
}
